<template>
  <div :class="sectionClass">
    <label :for="id" class="form-label">{{ label }}</label>
    <div>
      <Calendar
        inputId="basic"
        :id="id"
        :type="type"
        :placeholder="placeholder"
        :disabled="disabled"
        :disabledDays="disabledDays"
        :disabledDates="disabledDates"
        :manualInput="manualInput"
        :modelValue="modelValue"
        :minDate="minDate"
        :maxDate="maxDate"
        :class="{
          'p-invalid':
            (validated && customfield && validation) ||
            (validation && validation.$error),
        }"
        :aria-describedby="`${id}-help`"
        timeOnly
        showIcon
        @date-select="$emit('update:modelValue', $event)"
      />
    </div>
    <span
      v-if="
        (validated && customfield && validation) ||
        (validation &&
          validation.$error &&
          validation.required.$invalid &&
          validation.required)
      "
      :id="`${id}-help`"
      class="p-error text-left mt-2"
    >
      {{
        validated && customfield && validation
          ? validation.$message.replace("Value", this.label)
          : validation.required.$message.replace("Value", this.label)
      }}
    </span>
    <!-- <span
      v-if="
        validation?.$error &&
        validation.required &&
        validation.required.$invalid
      "
      :id="`${id}-help`"
      class="p-error text-left mt-2"
    >
      {{ validation.required.$message.replace("Value", this.label) }}
    </span> -->
  </div>
</template>

<script>
// import moment from "moment";

export default {
  props: {
    sectionClass: {
      type: String,
      default: "field",
    },
    id: {
      type: String,
      required: true,
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    label: {
      type: String,
      required: true,
      default: "",
    },
    customfield: {
      type: Boolean,
      default: false,
    },
    validated: {
      type: Boolean,
      default: false,
    },
    validation: {
      type: Object,
      required: true,
    },
    minlength: {
      type: String,
      default: "",
    },
    maxlength: {
      type: String,
      default: "",
    },
    modelValue: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disabledDates: {
      type: Array,
      default: null,
    },
    disabledDays: {
      type: Array,
      default: null,
    },
    manualInput: {
      type: Boolean,
      default: true,
    },
    minDate: {
      type: Date,
      default: null,
    },
    maxDate: {
      type: Date,
      default: null,
    },
  },
};
</script>
